enum ViewType {
    WEB = 'web',
    TABLET = 'tablet',
    MOBILE = 'mobile'
}

enum DeviceType {
    WEB = 'device-web',
    MOBILE = 'device-mobile'
}

enum OrientationType {
    PORTRAIT = 'port',
    LANDSCAPE = 'land'
}

enum AppThemes {
    LIGHT = 'light-theme',
    DARK = 'dark-theme',
    TRANSITION = 'changing-theme'
}

const MOBILE_WIDTH_MAX = 680;
const MOBILE_HEIGHT_MAX = 980;

const TABLET_PORTRAIT_WIDTH_MIN = 480;
const TABLET_PORTRAIT_HEIGHT_MIN = 980;

const TABLET_PORTRAIT_WIDTH_MAX = 1024;
const TABLET_PORTRAIT_HEIGHT_MAX = 1366;

const TABLET_LANDSCAPE_WIDTH_MIN = 980;
const TABLET_LANDSCAPE_HEIGHT_MIN = 480;

const TABLET_LANDSCAPE_WIDTH_MAX = 1366;
const TABLET_LANDSCAPE_HEIGHT_MAX = 1024;

const isMobile = (width: number, height: number) =>
    width < MOBILE_WIDTH_MAX && height < MOBILE_HEIGHT_MAX;

const isTablet = (width: number, height: number) =>
    width > TABLET_PORTRAIT_WIDTH_MIN &&
    width <= TABLET_PORTRAIT_WIDTH_MAX &&
    height > TABLET_PORTRAIT_HEIGHT_MIN &&
    height <= TABLET_PORTRAIT_HEIGHT_MAX;

const isTabletL = (width: number, height: number) =>
    width >= TABLET_LANDSCAPE_WIDTH_MIN &&
    width < TABLET_LANDSCAPE_WIDTH_MAX &&
    height >= TABLET_LANDSCAPE_HEIGHT_MIN &&
    height < TABLET_LANDSCAPE_HEIGHT_MAX;

const isTabletP = isTablet;

export const getViewType = () => {
    const width = innerWidth;
    const height = innerHeight;

    applyBodyDeviceClass();

    if (isMobile(width, height) || isTabletP(width, height)) {
        return ViewType.MOBILE;
    } else {
        return ViewType.WEB;
    }
}

export const getDeviceOrientation = () => {
    const width = innerWidth;
    const height = innerHeight;

    if (width >= height) {
        return OrientationType.LANDSCAPE;
    } else {
        return OrientationType.PORTRAIT;
    }
}

export const getDeviceType = () => {
    let width = innerWidth;
    let height = innerHeight;

    if (isMobile(width, height)) {
        return DeviceType.MOBILE;
    } else if (isTablet(width, height)) {
        width = outerWidth;
        height = outerHeight;

        if (isTabletL(width, height)) {
            return DeviceType.WEB;
        }

        return DeviceType.MOBILE;
    } else {
        return DeviceType.WEB;
    }
}

const applyBodyDeviceClass = () => {
    const deviceType = getDeviceType();
    const body = document.body;
    body.classList.remove(DeviceType.MOBILE);
    body.classList.remove(DeviceType.WEB);
    body.classList.add(deviceType);
}

const SCROLL_TOP = 0;
const SCROLL_MIN_LIMIT = 25;

export const onChildrenScroll = (event: any, parentClass: string) => {
    const currentY = event.target.scrollTop;
    const parent = document.querySelector(`.${parentClass}`);
    if (parent) {
        if (currentY <= SCROLL_MIN_LIMIT) {
            parent.classList.remove('shadow-on-scroll');
            if (currentY < 0) {
                (event.target as HTMLElement).scrollTop = SCROLL_TOP;
            }
        } else {
            parent.classList.add('shadow-on-scroll');
        }
    }
}

export const applyUserTheme = (selectedTheme: AppThemes) => {
    const bodyComponent = document.body;
    if (selectedTheme === AppThemes.LIGHT) {
        bodyComponent.classList.remove(AppThemes.DARK);
        bodyComponent.classList.add(AppThemes.LIGHT);
    }
    if (selectedTheme === AppThemes.DARK) {
        bodyComponent.classList.remove(AppThemes.LIGHT);
        bodyComponent.classList.add(AppThemes.DARK);
    }
    return selectedTheme;
}

export const updateBodyForOutsidePages = () => {
    const bodyComponent = document.body;
    const outsideClass = 'outside-page';
    bodyComponent.classList.remove(outsideClass);
    bodyComponent.classList.add(outsideClass);
}
